import store from "../store";

const getNetwork = () => store.getState().network?.network;

const networkUtil = Object.freeze({
  getNetwork,
});

export default networkUtil;
